
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2063.196-1770a1.271 1.271 0 01-.1.5 1.362 1.362 0 01-.322.444l-7.126 6.986a1.159 1.159 0 01-.84.332 1.218 1.218 0 01-.615-.156 1.2 1.2 0 01-.44-.436 1.152 1.152 0 01-.166-.6 1.207 1.207 0 01.381-.879l6.367-6.191-6.371-6.191a1.186 1.186 0 01-.381-.879 1.144 1.144 0 01.166-.605 1.2 1.2 0 011.055-.586 1.142 1.142 0 01.84.342l7.129 6.973a1.253 1.253 0 01.322.439 1.307 1.307 0 01.101.507z"}})])])
          )
        }
      }
    